module.exports = __webpack_public_path__ + "img/cov-collaboration.dcbeb764.jpg";